import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import {
  loadFormsySubmissionV2,
  saveFormsyV2,
  dataChange,
} from "./supervisionScripts";
import Input from "../common/Input";
import Select from "../common/Select";
import Checkbox from "../common/Checkbox";
import SupervisionHeader from "./SupervisionHeader";
import Comments from "./Comments";
import Signatures from "./Signatures";

function Group(props) {
  let { supervisionLogId } = useParams();
  const [data, setData] = useState({});
  const [touched, setTouched] = useState({});
  const [timeoutId, setTimeoutId] = useState(null);
  const pdfRef = useRef(true);
  const safyInfo = JSON.parse(localStorage.getItem("safyInfo"));

  const timeOptions = [
    { name: "0:15", _id: "15" },
    { name: "0:30", _id: "30" },
    { name: "0:45", _id: "45" },
    { name: "1:00", _id: "60" },
    { name: "1:15", _id: "75" },
    { name: "1:30", _id: "90" },
    { name: "1:45", _id: "105" },
    { name: "2:00", _id: "120" },
    { name: "2:15", _id: "135" },
    { name: "2:30", _id: "150" },
    { name: "2:45", _id: "165" },
    { name: "3:00", _id: "180" },
  ];

  useEffect(() => {
    loadForm();
  }, [supervisionLogId]);

  const loadForm = () => {
    loadFormsySubmissionV2(supervisionLogId, setData);
  };

  const handleChange = ({ currentTarget: input }) => {
    dataChange(
      input,
      data,
      setData,
      touched,
      setTouched,
      timeoutId,
      setTimeoutId
    );
  };

  const isSupervisee = () => {
    return (
      safyInfo.user.azureId.toUpperCase() === data.PrimaryObjectId.toUpperCase()
    );
  };

  const isSupervisor = () => {
    return (
      safyInfo.user.azureId.toUpperCase() ===
      data.SecondaryObjectId.toUpperCase()
    );
  };

  const superviseeSigned =
    data?.Related?.filter(
      (s) => s.ObjectType === "Signature" && s.ObjectJSON.role === "Supervisee"
    ).length > 0
      ? true
      : false;

  return (
    <div ref={pdfRef}>
      <div className="">
        <SupervisionHeader
          label="Group Supervision"
          data={data}
          canClone={true}
          canDelete={isSupervisee && data.FinalSigned === false}
          handleSave={() => saveFormsyV2(data, "Update")}
          pdfRef={pdfRef}
        />
        <div className="row mt-4">
          <div className="col-6">
            <Input
              name="DateSupervision"
              label="Date of Supervision"
              value={data.Results?.DateSupervision}
              type="date"
              onChange={handleChange}
              disabled={!isSupervisee || superviseeSigned}
            ></Input>
          </div>
          <div className="col-6">
            <Select
              name="LengthOfSupervision"
              label="Length of Supervision Session"
              options={timeOptions}
              value={data && data.Results?.LengthOfSupervision}
              onChange={handleChange}
              disabled={!isSupervisee || superviseeSigned}
            ></Select>
          </div>
        </div>
        <div className="row mt-2">
          <div className="col ps-4 ms-2 pt-4">
            <Checkbox
              name="CountsAsLicensure"
              label="This supervision counts towards staff licensure"
              checked={data.Results?.CountsAsLicensure === true}
              onChange={handleChange}
              disabled={!isSupervisee || superviseeSigned}
            ></Checkbox>
          </div>
          <div className="col">
            <Select
              name="LengthOfLicensure"
              label="Time towards Licensure Supervision (If Applicable)"
              options={timeOptions}
              value={data.Results?.LengthOfLicensure}
              onChange={handleChange}
              disabled={!isSupervisee || superviseeSigned}
            ></Select>
          </div>
        </div>
        <Input
          name="CaseReviews"
          label="Case Reviews"
          value={data.Results?.CaseReviews}
          onChange={handleChange}
          disabled={!isSupervisee || superviseeSigned}
        ></Input>
        <Input
          name="IdentifiedResources"
          label="Identified Resources"
          value={data.Results?.IdentifiedResources}
          onChange={handleChange}
          disabled={!isSupervisee || superviseeSigned}
        ></Input>
        <Input
          id="Other"
          className="form-control"
          name="Other"
          label="Other"
          value={data.Results?.Other}
          onChange={handleChange}
          disabled={!isSupervisee || superviseeSigned}
        ></Input>
      </div>
      <Comments data={data} refresh={loadForm} />
      <Signatures
        data={data}
        isSupervisee={isSupervisee}
        isSupervisor={isSupervisor}
        handleSave={() => saveFormsyV2(data, "Update")}
        callback={loadForm}
        lockedOn="Supervisee"
      />
    </div>
  );
}

export default Group;
